import React from 'react';
import { connect } from 'react-redux';
import { updateSubmissionByKey } from '../actions';
import { Checkbox, FormGroup, Row, Col } from 'react-bootstrap';
import { commifyNumber } from '../../utils/utilities';
import ConvertibleText from '../../components/shared/ConvertibleText';

const OPTIONAL_FORMS = [
];

class OptionalFormsSelector extends React.Component {
    constructor(props) {
        super(props);
        this.handleFormSelectionOnChange = this.handleFormSelectionOnChange.bind(this);
        this.handleU653DeductibleOnChange = this.handleU653DeductibleOnChange.bind(this);
        this.state = {
            manaullyUpdated: undefined,
        }
    }

    componentDidUpdate = (prevProps) => {
        if (this.props.coverage === 'deductibleWarranty'
            && prevProps.coverage !== 'deductibleWarranty') {
            const event = {
                target : {
                    checked : true, value : 'u653'
                }
            }
            this.handleFormSelectionOnChange(event, true)
        }
        if (
            this.props.coverage !== 'deductibleWarranty' && prevProps.coverage === 'deductibleWarranty'
        ) {
            /**
             * 1. Reset u653 data if base coverage changes and is not standard coverage 
             * 2. Or reset if user switches to System Generated Pricing
             **/
            if (this.props.submission.optionalForms && this.props.submission.optionalForms.u653) {
                this.props.dispatch(
                    updateSubmissionByKey({
                        key: 'optionalForms',
                        value: {
                            ...this.props.submission.optionalForms,
                            u653: {
                                isSelected: false,
                            },
                        },
                    })
                );
            }
            if (Object.hasOwn(this.props.pricingValues, 'u653Deductible')) {
                this.props.onBlurHandler({
                    u653Deductible: null,
                });
            }
        }
    };

    componentDidMount() {
        const { submission, manuallySetPricing, pricingValues, coverage } =
            this.props;
        if (!['deductibleWarranty'].includes(coverage)) {
            if (submission.optionalForms && submission.optionalForms.u653 && this.state.manaullyUpdated !== undefined) {
                this.props.dispatch(
                    updateSubmissionByKey({
                        key: 'optionalForms',
                        value: {
                            ...submission.optionalForms,
                            u653: {
                                isSelected: false,
                            },
                        },
                    })
                );
            }
            if (pricingValues.u653Deductible !== null
            && pricingValues.u653Deductible !== undefined) {
                this.props.onBlurHandler({
                    u653Deductible: null,
                });
            }
        }
    }

    handleU653DeductibleOnChange(evt) {
        let u653Deductible = undefined;
        if (evt.target.value !== '$') {
            u653Deductible = Number(evt.target.value.replace(/[$,%,+]/g, ''));
        }
        this.props.onBlurHandler({
            u653Deductible: u653Deductible,
        });
    }

    handleFormSelectionOnChange(evt, manualUpdate) {
        if (!!manualUpdate) {
            this.setState({
                manaullyUpdated: true
            })
        } else {
            this.setState({
                manaullyUpdated: false
            })
        }
        if (evt.target.value) {
            this.props.dispatch(
                updateSubmissionByKey({
                    key: 'optionalForms',
                    value: {
                        ...this.props.submission.optionalForms,
                        [evt.target.value]: {
                            isSelected: evt.target.checked,
                        },
                    },
                })
            );
            if (evt.target.value === 'u653') {
                // Set default value when the u653 checkbox is selected
                let deductible = null;
                if (evt.target.checked && !Number.isNaN(this.props.submission.totalCost)) {
                    if (Number(this.props.submission.totalCost) <= 25000000) {
                        deductible = 25000;
                    } else if (Number(this.props.submission.totalCost) > 25000000) {
                        deductible = 50000;
                    }
                }
                this.props.onBlurHandler({
                    u653Deductible: deductible,
                });
            }
        }
    }

    render() {
        const {
            submission,
            pricingValues: { u653Deductible },
            coverage,
            manuallySetPricing,
            isUnderwriter,
            onBlurHandler,
        } = this.props;
        if (!manuallySetPricing || !isUnderwriter || !['deductibleWarranty'].includes(coverage)) {
            return null;
        }

        const u653DeductibleFormatted =
            u653Deductible !== 0 ? commifyNumber(u653Deductible) : u653Deductible;

        return (
            <Row>
                <Col xs={8} md={6}>
                    <FormGroup className="checkbox-group">
                        {OPTIONAL_FORMS.map((optionalForm) => {
                            let isSelected = false;
                            if (
                                submission.optionalForms &&
                                submission.optionalForms[optionalForm.formKey]
                            ) {
                                isSelected =
                                    submission.optionalForms[optionalForm.formKey].isSelected === true ||
                                    submission.optionalForms[optionalForm.formKey].isSelected === 'true';
                            }
                            return (
                                <div className="optionalFormsContainer" key={optionalForm.formKey}>
                                    <Checkbox
                                        className="optionalFormCheckbox"
                                        onChange={this.handleFormSelectionOnChange}
                                        value={optionalForm.formKey}
                                        checked={isSelected}
                                        disabled={true}
                                    >
                                        {optionalForm.label}
                                    </Checkbox>

                                    {isSelected === true && optionalForm.formKey === 'u653' && (
                                        <div className="optionalFormBox">
                                            <span className="h5">Deductible</span>
                                            <span>
                                                <ConvertibleText
                                                    manuallySetPricing={manuallySetPricing}
                                                    value={{
                                                        name: 'u653Deductible',
                                                        text: `${u653DeductibleFormatted}`,
                                                    }}
                                                    onBlurHandler={onBlurHandler}
                                                    onChange={this.handleU653DeductibleOnChange}
                                                />
                                            </span>
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </FormGroup>
                </Col>
            </Row>
        );
    }
}

/**
 * This function will return true if u653Deductible data is applicable or false if not applicable
 * 
 * @param {string} baseCoverage
 * @param {string} type
 * @param {Boolean} manuallySetPricing
 * @param {Boolean} isUnderwriter
 */

 // As part of ArgoPI enhancement, the requirement needs to remove the explicit optional form section in OE.
 // This logic can be re-written based on future requirement. 
export const isU653Applicable = (baseCoverage, type) => {
    return false;
};

const connectedOptionalFormsSelector = connect()(OptionalFormsSelector);

export { connectedOptionalFormsSelector as OptionalFormsSelector}
